<template>
  <div class="module_left_line" :style="{ borderLeft: '1px solid #d9dbe2' }">
    <div class="module_left">
      <div class="module_name">
        {{ view.name }}
        <span class="module_line"></span>
        <span class="module_v_line" v-if="view.funcs && view.funcs.length > 12"></span>
      </div>
      <div style="margin-left: 12px; position: absolute" :style="{ left: switchStyle }">
        <el-switch :disabled="!headCheckAll" v-model="value" active-color="#6669e3" inactive-color="#b8b8c4"
          :active-value="true" :inactive-value="false" @change="handleCheckAllChange"></el-switch>
      </div>
      <div style="display: block; width: 90%" :style="{ marginLeft: checkStyle }">
        <el-checkbox-group v-model="funcIds">
          <el-checkbox v-for="func in view.funcs" :label="func.id" :key="func.id" style="margin-left: 0px"
            v-if="func.type == 4" :disabled="!value || func.disabled">{{ func.name }}</el-checkbox>
        </el-checkbox-group>
        <el-radio-group v-model="radiofuncIds">
          <el-radio v-for="func in view.funcs" :label="func.id" :key="func.id" style="margin-left: 0px"
            v-if="func.type == 5" :disabled="!value || func.disabled">{{ func.name }}</el-radio>
        </el-radio-group>
      </div>
    </div>
    <slot></slot>
  </div>
</template>
<script>
import { title } from 'process';

export default {
  name: "PermissionContent",
  data () {
    return {
      codes: [],
      value: this.headCheckAll,
      funcIds: this.view.funcsId,
      radiofuncIds: this.view.funcsId[0]
    };
  },
  props: {
    switchStyle: {
      type: String,
      default: "152px",
    },
    checkStyle: {
      type: String,
      default: "180px",
    },
    view: {
      type: Object,
    },
    headCheckAll: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    headCheckAll: function (n) {

      this.value = n;
      this.handleCheckAllChange(n);
    },
    funcIds (n) {
      console.log(n,this.funcIds.length)
      // if (!this.funcIds.length) return
      this.$emit("handCheck", this.view, n);

    },
    radiofuncIds (n) {
      if (!this.radiofuncIds) return
      this.$emit("handCheck", this.view, [n]);
    }
  },

  created () {
    this.value = this.view.switched;
  },

  methods: {
    handleCheckAllChange (val) {
      

      this.funcIds = [];
      this.radiofuncIds = ''
      if (val) {
        if (this.view.funcs) {
          for (var i = 0; i < this.view.funcs.length; i++) {
            if (this.view.funcs[i].type == 4) {
              this.funcIds.push(this.view.funcs[i].id);
            }
          }
          if (this.view.funcs[0] && this.view.funcs[0].type == 5) {
            this.radiofuncIds = this.view.funcs[0].id
          }
        }
      }
      this.$emit("switchChange", this.view, val);
    },
  },
};
</script>
<style scoped>
.module_left_line {
  font-size: 12px;
  margin-left: 20px;
  font-weight: bold;
  text-align: left;
}

.module_left {
  margin-left: 10px;
  display: inline-flex;
  margin-top: 20px;
  position: relative;
  width: 100%;
}

/* .module_left_line:before{
        content: "";
            position: absolute;
            left: 0;
            top: -2px;
            width: 50%;
            height: 2px;
            background-color: red

    } */
.module_name {
  width: 80px;
  position: relative;
}

.module_line {
  position: absolute;
  background: #d9dbe2;
  width: 10px;
  height: 1px;
  left: -10px;
  top: 8px;
}

.module_last_cover {
  width: 10px;
  height: 300px;
  display: block;
  position: absolute;
  left: -30px;
  top: 9px;
  background: white;
}

.module_v_line {
  width: 10px;
  height: 30px;
  display: block;
  position: absolute;
  left: 10px;
  width: 1px;
  top: 9px;
  background: #d9dbe2;
}
</style>

